import { usePrimeVue } from "primevue/config";
import { useI18n } from "vue-i18n";
import { messaggi } from "~/i18n/messaggi";

// Tiene allineati i testi interni di PrimeVue (calendario, filtri, paginatore...) con la lingua attiva di vue-i18n.
// I testi stanno in `app/i18n/locales/<lingua>/primevue.json`. Si chiama una volta, in app.vue.
export function usePrimeVueLocale(): void {
  const primevue = usePrimeVue();
  const { locale } = useI18n();

  function applica(lingua: string): void {
    const normalizzata = String(lingua || "it").split("-")[0]!.toLowerCase();
    const testi = messaggi[normalizzata]?.["primevue"];
    if (!testi || typeof testi !== "object") return;
    Object.assign(primevue.config.locale ?? {}, testi);
  }

  onMounted(() => applica(locale.value));
  watch(locale, applica);
}
